import {Widget} from "base/assets/js/widget/Widget.js";
import {Comms} from "base/assets/js/widget/Comms.js";
import {Comm} from "base/assets/js/widget/Comm.js";

export class CommsExpandBtn extends Widget {

	_sMpFrom;
	_sMpTo;
	_aMpFrom;
	_aMpTo;
	_oComms;

	run() {
		this._on( '', 'click', ( oEvent ) => {
			const { sMpFrom, sMpTo } = this._attrs( '', { 'mp-from': 'sMpFrom', 'mp-to': 'sMpTo' } );
			this._getComms().loadByRange( sMpFrom, sMpTo, {} );
		} );
	}

	toggle( bValue ) {
		this._mod( '', 'comms__expand-btn_hide', !bValue );
	}

	_getComms() {
		if( !this._oComms ) {
			this._oComms = this._rel().parent().typeOf(Comms).find();
		}
		return this._oComms;
	}
}
